"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dummyContractAddrs = exports.baseTokenURI = exports.avatarWhiteUrl = exports.avatarBlueUrl = exports.imageUrl = exports.imagePath = void 0;
exports.imagePath = "https://storage.googleapis.com/cdn.gemunion.io/FIREBASE_IMG/DO_NOT_REMOVE";
exports.imageUrl = "https://storage.googleapis.com/cdn.gemunion.io/FIREBASE_IMG/DO_NOT_REMOVE/logo.png";
exports.avatarBlueUrl = "https://storage.googleapis.com/cdn.gemunion.io/FIREBASE_IMG/DO_NOT_REMOVE/avatar_blue.png";
exports.avatarWhiteUrl = "https://storage.googleapis.com/cdn.gemunion.io/FIREBASE_IMG/DO_NOT_REMOVE/avatar_white.png";
exports.baseTokenURI = "http://localhost:3011/metadata/";
exports.dummyContractAddrs = [
    "0xcc7d26d8ea6281bb363c8448515f2c61f7bc19f0",
    "0x0e8d6b471e332f140e7d9dbb99e5e3822f728da6",
    "0xb6c3dc857845a713d3531cea5ac546f6767992f4",
    "0xade00c28244d5ce17d72e40330b1c318cd12b7c3",
    "0x5ca9a71b1d01849c0a95490cc00559717fcf0d1d",
];
//# sourceMappingURL=mocks.js.map